import React, { useState } from "react";

export default function DeleteAccountPage() {
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");
    const [password, setPassword] = useState("");

    const handleDelete = async () => {
        if (!email) {
            setMessage("Please enter a valid email.");
            return;
        }

        setLoading(true);
        setMessage("");

        try {
            const response = await fetch(`https://admin.onmls.com/api/delete-user-account`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    email,
                    password: "password",
                }),
            });

            if (response.ok) {
                setMessage("Your account has been deleted successfully.");
                setEmail("");
            } else {
                const result = await response.json();
                setMessage(result.message || "Failed to delete the account.");
            }
        } catch (error) {
            setMessage("An error occurred while deleting your account.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="tw-min-h-screen tw-bg-gray-100 tw-flex tw-items-center tw-justify-center tw-p-4">
            <div className="tw-max-w-md tw-w-full tw-bg-white tw-p-6 tw-rounded-2xl tw-shadow-md">
                <h1 className="tw-text-2xl tw-font-bold tw-text-red-600 tw-mb-2">Delete Your Account</h1>
                <p className="tw-text-gray-600 tw-mb-4">
                    Deleting your account is permanent and cannot be undone. All your data will be erased from our system.
                </p>

                <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Enter your email"
                    className="tw-w-full tw-p-3 tw-border tw-border-gray-300 tw-rounded-xl tw-mb-4 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-red-500"
                />

                <input
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Enter your password"
                    className="tw-w-full tw-p-3 tw-border tw-border-gray-300 tw-rounded-xl tw-mb-4 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-red-500"
                />

                <button
                    onClick={handleDelete}
                    disabled={loading}
                    className="tw-w-full tw-bg-red-600 tw-text-white tw-py-3 tw-rounded-xl tw-font-semibold hover:tw-bg-red-700 tw-transition"
                >
                    {loading ? "Deleting..." : "Delete Account"}
                </button>

                {message && <p className="tw-mt-4 tw-text-center tw-text-sm tw-text-gray-700">{message}</p>}
            </div>
        </div>
    );
}
